import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Typography,
  Button,
  Paper,
  Container,
  Fade,
  Stack,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  Divider,
  IconButton,
  Zoom,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import {
  CalendarMonth,
  AccessTime,
  ConfirmationNumberOutlined,
  ArrowBackIos,
  ArrowForwardIos,
  InfoOutlined,
  LocationOn,
  Videocam,
  Payments,
  ConfirmationNumber, // Corrigé ici
  Close,
  Devices,
  Hub,
  Directions,
  LockPerson,
} from "@mui/icons-material";
import moment from "moment";
import "moment/locale/fr";
import axios from "axios";
import { toast } from "react-toastify";
import LocalStorage from "../../../../../Utils/localStorageService";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Zoom ref={ref} {...props} />;
});
export default function WorkshopAutoScrollStyle({ userData }) {
  const [activeIdx, setActiveIdx] = useState(0);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [selectedSession, setSelectedSession] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isHovered, setIsHovered] = useState(false); // État pour gérer le hover
  const [clientInfo, setClientInfo] = useState({
    etatAbn: null,
    nbrWorkshop: null,
    idClient: null,
  });
  const workshops = userData?.workshops || [];
  const currentWS = workshops[activeIdx];
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [loginModal, setLoginModal] = useState(false);
  const isLoggedIn = !!LocalStorage.getAccessToken();
  // --- LOGIQUE DE DÉFILEMENT AUTOMATIQUE ---
  useEffect(() => {
    let interval;
    if (!isHovered && !isPopupOpen && workshops.length > 0) {
      interval = setInterval(() => {
        setActiveIdx((prev) => (prev + 1) % workshops.length);
      }, 3500); // Change toutes les 3.5 secondes
    }
    return () => clearInterval(interval);
  }, [isHovered, isPopupOpen, workshops.length]);

  useEffect(() => {
    const token = LocalStorage.getAccessToken();
    if (token) {
      axios
        .get(`${process.env.REACT_APP_APIURL}/client/g/get/p/profile`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(({ data }) => {
          if (data.status === "success") {
            setClientInfo({
              etatAbn: data.result.etat_abn,
              idClient: data.result.id_client,
              nbrWorkshop: data.result.nbr_workshops,
              participants: data.result.participants || [],
            });
          }
        })
        .catch(console.error);
    }
  }, []);

  const handleConfirmReservation = async () => {
    setLoading(true);
    const token = LocalStorage.getAccessToken();

    try {
      if (
        clientInfo?.etatAbn === 1 &&
        clientInfo?.nbrWorkshop > 0 &&
        currentWS?.is_accessible_participant === 1
      ) {
        const res = await axios.post(
          `${process.env.REACT_APP_APIURL}/process-order-workshops-abonner/public/c`,
          {
            id_sessions: selectedSession?.id_wss,
            id_ws: currentWS?.id_ws,
            id_client: clientInfo?.idClient,
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );

        toast.success("Réservation réussie");

        window.location.href = `/message?message=${encodeURIComponent(
          "Votre réservation est bien confirmé, vous avez donc utilisé un crédit pour cet atelier",
        )}`;
      } else {
        const { data } = await axios.post(
          `${process.env.REACT_APP_BILLING_URL}/create-checkout-session`,
          {
            itemToBuyId: currentWS?.id_ws,
            itemToBuyType: "WORKSHOPS",
            sessionid: selectedSession?.id_wss,
            token,
          },
          {
            headers: { "Content-Type": "application/json" },
          },
        );

        if (data?.url) window.location.href = data.url;
      }
    } catch (err) {
      console.error("API ERROR:", err?.response?.data || err.message);
      toast.error(err?.response?.data?.message || "Erreur serveur");
    } finally {
      setLoading(false);
    }
  };

  if (!workshops.length) return null;
  // Déterminer si l'utilisateur va utiliser un crédit d'abonnement
  const isUsingSubscription =
    clientInfo?.etatAbn === 1 &&
    clientInfo?.nbrWorkshop > 0 &&
    currentWS?.is_accessible_participant === 1;

  const alertMessage = isUsingSubscription
    ? "Vous pouvez réserver cet atelier en utilisant un crédit inclus dans votre abonnement mensuel, sans frais supplémentaires."
    : "Cette session nécessite un règlement pour valider votre place.";

  const alertSeverity = isUsingSubscription ? "info" : "warning";

  const reservedSessionIds =
    clientInfo?.participants?.map((p) => p.id_wss_wsp) || [];
  return (
    <Box
      sx={{ minHeight: "100vh", py: 8 }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}>
      <Container maxWidth="md">
        <Box sx={{ textAlign: "center", mb: 6 }}>
          <Typography
            variant="body1"
            sx={{
              maxWidth: "700px",
              mx: "auto",
              color: "#1D1D1F",
              fontWeight: 800,
              lineHeight: 1.6,
            }}>
            Les intervenants proposent des ateliers en présentiel ou en
            visioconférence, <br />
            que les clients de la plateforme peuvent réserver en seulement deux
            clics.
          </Typography>
        </Box>
        {/* NAVIGATION DES ATELIERS (S'ARRÊTE AU HOVER) */}
        <Stack
          direction="row"
          spacing={2}
          justifyContent="center"
          alignItems="center"
          sx={{ mb: 6 }}>
          <IconButton
            onClick={() =>
              setActiveIdx((prev) =>
                prev > 0 ? prev - 1 : workshops.length - 1,
              )
            }>
            <ArrowBackIos sx={{ fontSize: 18, color: "#D1B191" }} />
          </IconButton>

          <Stack
            direction="row"
            spacing={1.5}
            sx={{ overflowX: "auto", py: 1, scrollbarWidth: "none" }}>
            {workshops.map((ws, index) => (
              <Button
                key={index}
                onClick={() => {
                  setActiveIdx(index);
                  setIsHovered(true);
                }}
                sx={{
                  borderRadius: "20px",
                  px: 4,
                  py: 1,
                  textTransform: "none",
                  fontWeight: 700,
                  whiteSpace: "nowrap",
                  bgcolor: activeIdx === index ? "#4AAE9B" : "#EEEFEE",
                  color: activeIdx === index ? "#FFF" : "#777",
                  boxShadow:
                    activeIdx === index
                      ? "0 8px 20px rgba(74, 174, 155, 0.2)"
                      : "none",
                  transition: "0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                  "&:hover": {
                    bgcolor: activeIdx === index ? "#3d9685" : "#E0E0E0",
                  },
                }}>
                {ws.title_ws}
              </Button>
            ))}
          </Stack>

          <IconButton
            onClick={() =>
              setActiveIdx((prev) => (prev + 1) % workshops.length)
            }>
            <ArrowForwardIos sx={{ fontSize: 18, color: "#D1B191" }} />
          </IconButton>
        </Stack>

        {/* CARTE CENTRALE DYNAMIQUE */}
        <Fade in={true} key={activeIdx} timeout={600}>
          <Paper
            elevation={0}
            sx={{
              p: 5,
              borderRadius: "45px",
              border: "1px solid #F0F0F0",
              boxShadow: "0 25px 50px -12px rgba(0,0,0,0.05)",
              bgcolor: "#FFF",
            }}>
            <Box
              sx={{
                mb: 4,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
              }}>
              <Box>
                <Typography
                  variant="caption"
                  sx={{
                    color: "#4AAE9B",
                    fontWeight: 800,
                    letterSpacing: 1.5,
                  }}>
                  CALENDRIER DES ATELIERS
                </Typography>
                <Typography
                  variant="h4"
                  sx={{ fontWeight: 900, mt: 1, color: "#1D1D1F" }}>
                  {currentWS.title_ws}
                </Typography>
              </Box>
              {/*  <Chip 
                label={isHovered ? "Pause" : "Défilement actif"} 
                size="small" 
                sx={{ fontWeight: 700, fontSize: "0.6rem", bgcolor: isHovered ? "#F4F4F7" : "#F0F9F7", color: isHovered ? "#888" : "#4AAE9B" }} 
              /> */}
            </Box>

            <Stack spacing={2.5}>
              {currentWS.sessions.map((session, sIdx) => {
                const isFull =
                  session.participant_count_wss >= session.capacity;
                const isPast = moment(session.date_wss).isBefore(moment());
                const isReserved = reservedSessionIds.includes(session.id_wss);

                return (
                  <Box
                    key={sIdx}
                    sx={{
                      p: 3,
                      borderRadius: "28px",
                      border: "1px solid #F8F8F8",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      transition: "0.3s",
                      "&:hover": {
                        bgcolor: "#FAFAFB",
                        transform: "scale(1.01)",
                      },
                    }}>
                    <Stack direction="row" spacing={3} alignItems="center">
                      <Box
                        sx={{
                          bgcolor: "#F4F9F8",
                          p: 1.8,
                          borderRadius: "20px",
                          textAlign: "center",
                          minWidth: "70px",
                        }}>
                        <Typography
                          sx={{
                            fontWeight: 900,
                            fontSize: "1.2rem",
                            color: "#4AAE9B",
                            lineHeight: 1,
                          }}>
                          {moment(session.date_wss).format("DD")}
                        </Typography>
                        <Typography
                          sx={{
                            fontWeight: 700,
                            fontSize: "0.75rem",
                            color: "#4AAE9B",
                            textTransform: "uppercase",
                            mt: 0.5,
                          }}>
                          {moment(session.date_wss).format("MMM")}
                        </Typography>
                      </Box>
                      <Box>
                        <Typography
                          sx={{
                            fontWeight: 900,
                            fontSize: "1.3rem",
                            color: "#1D1D1F",
                          }}>
                          {moment(session.date_wss).format("HH[h]mm")}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ color: "#86868B", fontWeight: 600 }}>
                          {session.capacity - session.participant_count_wss}{" "}
                          places disponibles
                        </Typography>
                      </Box>
                    </Stack>

                    <Button
                      disabled={isFull || isPast || isReserved}
                      onClick={() => {
                        if (!isLoggedIn) {
                          setLoginModal(true);
                          return;
                        }

                        setSelectedSession(session);
                        setPopupOpen(true);
                      }}
                      variant="contained"
                      disableElevation
                      sx={{
                        borderRadius: "18px",
                        px: 5,
                        py: 1.5,
                        textTransform: "none",
                        fontWeight: 800,

                        bgcolor: isReserved
                          ? "#E8F5E9"
                          : isFull || isPast
                            ? "#E8E8ED"
                            : "#4AAE9B",

                        color: isReserved
                          ? "#2E7D32"
                          : isFull || isPast
                            ? "#A1A1A6"
                            : "#FFF",

                        "&:hover": {
                          bgcolor: isReserved
                            ? "#E8F5E9"
                            : isFull || isPast
                              ? "#E8E8ED"
                              : "#3d9685",
                        },
                      }}>
                      {isReserved
                        ? "Participation confirmée"
                        : isPast
                          ? "Terminé"
                          : isFull
                            ? "Complet"
                            : "Réserver"}
                    </Button>
                  </Box>
                );
              })}
            </Stack>
          </Paper>
        </Fade>
      </Container>

      {/* POPUP (Le style Ticket de ton image) */}
      <Dialog
        open={isPopupOpen}
        TransitionComponent={Transition}
        onClose={() => setPopupOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "30px",
            p: 0,
            boxShadow: "0 25px 80px rgba(0,0,0,0.18)",
            overflow: "hidden",
          },
        }}>
        {/* Header Médical / Bien-être */}
        <Box
          sx={{
            bgcolor: "#4AAE9B",
            py: 4,
            textAlign: "center",
            position: "relative",
            color: "white",
          }}>
          <IconButton
            onClick={() => setPopupOpen(false)}
            sx={{
              position: "absolute",
              right: 16,
              top: 16,
              color: "white",
              bgcolor: "rgba(255,255,255,0.2)",
            }}>
            <Close fontSize="small" />
          </IconButton>
          <ConfirmationNumber sx={{ fontSize: 50, mb: 1, opacity: 0.9 }} />
          <Typography variant="h5" sx={{ fontWeight: 800 }}>
            Confirmation
          </Typography>
        </Box>

        <DialogContent
          sx={{
            p: 3,
            bgcolor: "white",
            borderRadius: "24px 24px 0 0",
            mt: -2,
          }}>
          <Stack spacing={3}>
            <Box sx={{ textAlign: "center" }}>
              <Typography
                variant="caption"
                sx={{ color: "#4AAE9B", fontWeight: 800, letterSpacing: 1 }}>
                ATELIER SÉLECTIONNÉ
              </Typography>
              <Typography
                variant="h6"
                sx={{ fontWeight: 850, color: "#1D1D1F", mt: 0.5 }}>
                {currentWS?.title_ws}
              </Typography>
            </Box>

            {/* --- LE TICKET DESIGN --- */}
            <Box
              sx={{
                border: "2px solid #F2F2F7",
                borderRadius: "24px",
                overflow: "hidden",
              }}>
              {/* Ligne Date/Heure */}
              <Stack
                direction="row"
                divider={
                  <Divider
                    orientation="vertical"
                    flexItem
                    sx={{ borderStyle: "dashed" }}
                  />
                }
                sx={{ bgcolor: "#FAFAFC" }}>
                <Box sx={{ flex: 1, p: 2, textAlign: "center" }}>
                  <CalendarMonth
                    sx={{ color: "#4AAE9B", fontSize: 20, mb: 0.5 }}
                  />
                  <Typography
                    variant="caption"
                    display="block"
                    sx={{ color: "#8E8E93", fontWeight: 700 }}>
                    DATE
                  </Typography>
                  <Typography variant="body2" sx={{ fontWeight: 800 }}>
                    {selectedSession &&
                      moment(selectedSession.date_wss).format("DD MMM YYYY")}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1, p: 2, textAlign: "center" }}>
                  <AccessTime
                    sx={{ color: "#4AAE9B", fontSize: 20, mb: 0.5 }}
                  />
                  <Typography
                    variant="caption"
                    display="block"
                    sx={{ color: "#8E8E93", fontWeight: 700 }}>
                    HEURE
                  </Typography>
                  <Typography variant="body2" sx={{ fontWeight: 800 }}>
                    {selectedSession &&
                      moment(selectedSession.date_wss).format("HH[h]mm")}
                  </Typography>
                </Box>
              </Stack>

              <Divider sx={{ borderStyle: "dashed" }} />

              {/* Ligne Adresse / Format */}
              <Box sx={{ p: 2.5 }}>
                <Stack direction="row" spacing={2} alignItems="flex-start">
                  {/* Icône changeante selon le format */}
                  <Box
                    sx={{ bgcolor: "#F0F9F7", p: 1.2, borderRadius: "14px" }}>
                    {currentWS?.format_ws === "zoom" && (
                      <Videocam sx={{ color: "#4AAE9B" }} />
                    )}
                    {currentWS?.format_ws === "en_presentiel" && (
                      <LocationOn sx={{ color: "#4AAE9B" }} />
                    )}
                    {currentWS?.format_ws === "en_presentiel_et_zoom" && (
                      <Hub sx={{ color: "#4AAE9B" }} />
                    )}
                  </Box>

                  <Box sx={{ flex: 1 }}>
                    <Typography
                      variant="caption"
                      sx={{
                        color: "#8E8E93",
                        fontWeight: 700,
                        textTransform: "uppercase",
                        display: "block",
                        mb: 0.5,
                      }}>
                      Type de session
                    </Typography>

                    {/* Affichage du libellé exact du format */}
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: 800,
                        color: "#4AAE9B",
                        mb: 1,
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}>
                      {currentWS?.format_ws === "en_presentiel" &&
                        "📍 En Présentiel"}
                      {currentWS?.format_ws === "zoom" &&
                        "💻 En Visioconférence"}
                      {currentWS?.format_ws === "en_presentiel_et_zoom" &&
                        "🔄 Format Hybride (Mixte)"}
                    </Typography>

                    <Box sx={{ mt: 1 }}>
                      {/* CAS PRÉSENTIEL : On montre l'adresse */}
                      {(currentWS?.format_ws === "en_presentiel" ||
                        currentWS?.format_ws === "en_presentiel_et_zoom") && (
                        <Box
                          sx={{
                            p: 1.5,
                            borderLeft: "3px solid #E5E5EA",
                            bgcolor: "#FAFAFC",
                            mb:
                              currentWS?.format_ws === "en_presentiel_et_zoom"
                                ? 1
                                : 0,
                          }}>
                          <Typography
                            variant="body2"
                            sx={{
                              fontWeight: 700,
                              color: "#1D1D1F",
                              textTransform: "capitalize",
                            }}>
                            {currentWS?.address_ws || "Adresse à confirmer"}
                          </Typography>
                          <Typography
                            variant="caption"
                            sx={{ color: "#8E8E93", display: "block" }}>
                            {[currentWS?.city_ws, currentWS?.country_ws]
                              .filter(Boolean)
                              .join(", ")}
                          </Typography>
                          {currentWS?.lat_ws && (
                            <Button
                              startIcon={<Directions sx={{ fontSize: 14 }} />}
                              href={`https://www.google.com/maps/search/?api=1&query=${currentWS.lat_ws},${currentWS.lng_ws}`}
                              target="_blank"
                              sx={{
                                p: 0,
                                mt: 0.5,
                                color: "#4AAE9B",
                                fontSize: "0.65rem",
                                fontWeight: 700,
                                textTransform: "none",
                              }}>
                              Ouvrir l'itinéraire
                            </Button>
                          )}
                        </Box>
                      )}

                      {/* CAS ZOOM : On montre l'info visio */}
                      {(currentWS?.format_ws === "zoom" ||
                        currentWS?.format_ws === "en_presentiel_et_zoom") && (
                        <Box
                          sx={{
                            p: 1.5,
                            borderLeft: "3px solid #4AAE9B",
                            bgcolor: "#F0F9F7",
                            borderRadius: "0 8px 8px 0",
                          }}>
                          <Typography
                            variant="body2"
                            sx={{ fontWeight: 700, color: "#1D1D1F" }}>
                            Lien Zoom sécurisé
                          </Typography>
                          <Typography
                            variant="caption"
                            sx={{ color: "#3d9685", fontWeight: 500 }}>
                            {currentWS?.format_ws === "en_presentiel_et_zoom"
                              ? "Disponible si vous ne pouvez pas venir"
                              : "Envoyé par mail après confirmation"}
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  </Box>
                </Stack>
              </Box>

              {/* Ligne Prix avec style "Apple Wallet" */}
              <Box
                sx={{
                  p: 2,
                  bgcolor: "#1D1D1F",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}>
                <Typography
                  sx={{ color: "white", fontWeight: 600, fontSize: "0.85rem" }}>
                  Total à régler
                </Typography>
                <Typography
                  variant="h6"
                  sx={{ color: "#4AAE9B", fontWeight: 900 }}>
                  {isUsingSubscription ? "0,00 €" : `${currentWS?.price_ws} €`}
                </Typography>
              </Box>
            </Box>

            {/* Alerte */}
            <Alert
              severity={alertSeverity}
              icon={<InfoOutlined fontSize="small" />}
              sx={{
                borderRadius: "16px",
                bgcolor: alertSeverity === "info" ? "#F0F9F7" : "#FFF8F1",
                color: "#1D1D1F",
                border: "1px solid",
                borderColor: alertSeverity === "info" ? "#D1E9E4" : "#FFE2C4",
                "& .MuiAlert-message": { fontWeight: 600, fontSize: "0.8rem" },
              }}>
              {alertMessage}
            </Alert>
          </Stack>
        </DialogContent>

        <DialogActions sx={{ p: 3, pt: 1, flexDirection: "column", gap: 1.5 }}>
          <Button
            fullWidth
            variant="contained"
            onClick={handleConfirmReservation}
            sx={{
              bgcolor: "#4AAE9B",
              py: 1.8,
              borderRadius: "16px",
              fontWeight: 800,
              textTransform: "none",
              fontSize: "1rem",
              boxShadow: "0 10px 25px rgba(74, 174, 155, 0.3)",
              "&:hover": { bgcolor: "#3d9685" },
            }}>
            {isUsingSubscription
              ? "Confirmer avec un crédit"
              : `Payer ${currentWS?.price_ws} €`}
          </Button>
          <Button
            fullWidth
            onClick={() => setPopupOpen(false)}
            sx={{ color: "#8E8E93", fontWeight: 700, textTransform: "none" }}>
            Annuler
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={loginModal}
        onClose={() => setLoginModal(false)}
        PaperProps={{
          sx: {
            borderRadius: "24px",
            p: 3,
            maxWidth: "420px",
            width: "100%",
          },
        }}>
        <DialogContent>
          <Stack alignItems="center" spacing={3}>
            <LockPerson sx={{ fontSize: 60, color: "#4AAE9B" }} />

            <Typography variant="h5" fontWeight={900}>
              Connexion requise
            </Typography>

            <Typography textAlign="center" sx={{ color: "#707EAE" }}>
              Vous devez être connecté pour réserver un atelier et accéder aux
              sessions.
            </Typography>

            <Button
              fullWidth
              variant="contained"
              onClick={() => {
                window.location.href = "/login";
              }}
              sx={{
                bgcolor: "#4AAE9B",
                borderRadius: "16px",
                py: 2,
                fontWeight: 700,
                textTransform: "none",
              }}>
              Se connecter
            </Button>

            <Button
              onClick={() => setLoginModal(false)}
              sx={{ color: "#A3AED0", textTransform: "none" }}>
              Continuer sans connexion
            </Button>
          </Stack>
        </DialogContent>
      </Dialog>
    </Box>
  );
}
